import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { memo } from 'react';
import { getFaceLandmarkPositionsByHeadbustType } from '../../r3f-components/utils/face-tracking';
import FaceLandmarkHotspot from './FaceLandmarkHotspot';
const FaceLandmarkHotspots = () => {
    const positionDict = getFaceLandmarkPositionsByHeadbustType('uar');
    const hotspots = Object.entries(positionDict).map(([landmark, position]) => {
        return _jsx(FaceLandmarkHotspot, { landmark: landmark, position: position }, landmark);
    });
    return (_jsx(_Fragment, { children: hotspots }));
};
export default memo(FaceLandmarkHotspots);
